"use client";

import { useAppSelector } from "@v2/lib/redux/hooks";

export function useAuthSession() {
    const session = useAppSelector(s => s.general.session);
    const sessionLoaded = useAppSelector(s => s.general.sessionLoaded);

    return {
        isReady: sessionLoaded,
        isAuthenticated: sessionLoaded ? (session?.isAuthenticated ?? false) : false,
        session,
        user: session?.data?.user ?? null,
        accessToken: session?.data?.accessToken ?? null,
    };
}
